const SHEET_SELECTOR = ".modal-sheet, .recipe-sheet, .item-sheet";
const CLOSE_MS = 450;

export function mountAnimatedSheet(backdrop: HTMLElement): void {
    document.body.appendChild(backdrop);
    requestAnimationFrame(() => {
        requestAnimationFrame(() => {
            backdrop.classList.add("is-open");
        });
    });
}

export function closeAnimatedSheet(backdrop: HTMLElement, onDone?: () => void): void {
    if (backdrop.classList.contains("is-closing")) return;

    backdrop.classList.remove("is-open");
    backdrop.classList.add("is-closing");

    const sheet = backdrop.querySelector<HTMLElement>(SHEET_SELECTOR);
    let finished = false;

    const finish = (): void => {
        if (finished) return;
        finished = true;
        backdrop.removeEventListener("transitionend", onTransitionEnd);
        backdrop.remove();
        onDone?.();
    };

    const onTransitionEnd = (e: TransitionEvent): void => {
        if (sheet && e.target === sheet) finish();
    };

    if (sheet) {
        backdrop.addEventListener("transitionend", onTransitionEnd);
    }

    window.setTimeout(finish, CLOSE_MS);
}
